/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */

'use strict';
angular
  .module('http.activities', [])
  /**
   * Service used to access calls to the activities and audit-events rest services.
   */
  .factory('httpActivities', function ($http) {
    /**
     * Get all activities.
     * @param {Object} params - A parameters object
     * @param {Number} [params.limit=10] - The page size.
     * @param {Number} [params.offset=0] - The paging offset.
     * @param {String} [params.sort='date'] -  Property to sort by.
     * @param {Boolean} [params.ascending=true] - True to sort in ascending order.
     * @returns {list} A list of activities.
     */
    var getActivities = function (params) {
      var defaultParams = {
        limit: 10,
        offset: 0,
        sort: 'date',
        ascending: false
      };
      return $http({
        method: 'GET',
        url: 'api/activities',
        params: _.defaults(params, defaultParams)
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Get all audit events.
     * @param {Object} params - A parameters object
     * @param {Number} [params.limit=10] - The page size.
     * @param {Number} [params.offset=0] - The paging offset.
     * @param {String} [params.sort='date'] -  Property to sort by.
     * @param {Boolean} [params.ascending=true] - True to sort in ascending order.
     * @returns {list} A list of audit events.
     */
    var getAuditEvents = function (params) {
      var defaultParams = {
        limit: 10,
        offset: 0,
        sort: 'date',
        ascending: false
      };
      return $http({
        method: 'GET',
        url: 'api/audit-events',
        params: _.defaults(params, defaultParams)
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Function used to generate and download csv of activity history.
     * @returns {Promise} - A promise that resolves to an object containing a csv string
     */
    var downloadActivityHistoryCsv = function () {
      return $http({
        method: 'GET',
        url: 'api/activities/csv'
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Function used to generate and download csv of audit history.
     * @returns {Promise} - A promise that resolves to an object containing a csv string
     */
    var downloadAuditHistoryCsv = function () {
      return $http({
        method: 'GET',
        url: 'api/audit-events/csv'
      }).then(function (res) {
        return res.data;
      });
    };

    return {
      downloadActivityHistoryCsv: downloadActivityHistoryCsv,
      downloadAuditHistoryCsv: downloadAuditHistoryCsv,
      getActivities: getActivities,
      getAuditEvents: getAuditEvents
    };
  });
